import { render } from "./ExpertiseSection.vue?vue&type=template&id=7f62aa5e&scoped=true"
const script = {}

import "./ExpertiseSection.vue?vue&type=style&index=0&id=7f62aa5e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f62aa5e"]])

export default __exports__